// services/clusterInAppService.ts
import { requestFitplus } from '@/api';
import type { ClusterMapBaseInfoIn2DMapData, ClusterMapBaseInfoItem, ClusterResult } from '@common/cluster-common';

const endPoint = {
    GET_CLUSTER_3D_MAP_DATA:
        '/cluster/in-app-view/compared-cluster-in-3d-map?ComparedClusterID=#CLUSTER_ID#&DeclareDateTime=#DECLARE_DATE_TIME#&_ShareToken=#SHARE_TOKEN#',
    GET_CLUSTER_IN_APP_VIEW_RESULT: 'cluster/in-app-view/result?DeclareDateTime=#DECLARE_DATE_TIME#',
    GET_CLUSTER_SHARE_RESULT: 'cluster/in-app-view-shared/result',
    GET_CLUSTER_IN_APP_VIEW_2D_MAP_DATA:
        'cluster/in-app-view/compared-bodytype-in-2d-map?ComparedBodyTypeID=#COMPARED_BODY_TYPE_ID#&_ShareToken=#SHARE_TOKEN#&DeclareDateTime=#DECLARE_DATE_TIME#',
    GET_CLUSTER_TEST_IN_APP_VIEW_RESULT: 'cluster/TEST-in-app-view/result',
};

export const fetchClusterResult = (declareDateTime: string) =>
    requestFitplus<ClusterResult>(
        endPoint.GET_CLUSTER_IN_APP_VIEW_RESULT.replace('#DECLARE_DATE_TIME#', declareDateTime),
        'get',
    );

export const fetchClusterShareResult = (shareToken: string, declareDateTime: string) => {
    return requestFitplus<ClusterResult>(endPoint.GET_CLUSTER_SHARE_RESULT, 'get', {
        DeclareDateTime: declareDateTime,
        _ShareToken: shareToken,
    });
};

export const fetchCluster3DMapInfo = (clusterId: string, declareDateTime: string, shareToken: string) =>
    requestFitplus<ClusterMapBaseInfoItem>(
        endPoint.GET_CLUSTER_3D_MAP_DATA.replace('#CLUSTER_ID#', clusterId.toLowerCase())
            .replace('#DECLARE_DATE_TIME#', declareDateTime)
            .replace('#SHARE_TOKEN#', shareToken),
        'get',
    );

export const fetchCluster2DMapInfo = (bodyTypeId: string, declareDateTime: string, shareToken: string) =>
    requestFitplus<ClusterMapBaseInfoIn2DMapData>(
        endPoint.GET_CLUSTER_IN_APP_VIEW_2D_MAP_DATA.replace('#COMPARED_BODY_TYPE_ID#', bodyTypeId)
            .replace('#DECLARE_DATE_TIME#', declareDateTime)
            .replace('#SHARE_TOKEN#', shareToken),
        'get',
    );

export const fetchTestClusterResult = ({
    shareToken,
    currentClusterID,
    previousClusterID,
}: {
    shareToken: string;
    currentClusterID: string;
    previousClusterID: string;
}) =>
    requestFitplus<ClusterResult>(
        endPoint.GET_CLUSTER_TEST_IN_APP_VIEW_RESULT.replace('#SHARE_TOKEN#', shareToken)
            .replace('#CURRENT_CLUSTER_ID#', currentClusterID)
            .replace('#PREVIOUS_CLUSTER_ID#', previousClusterID),
        'get',
        {
            _ShareToken: shareToken,
            currentClusterID: currentClusterID,
            previousClusterID: previousClusterID,
        },
    );
